import { type UserProfile } from '../api/schema/profileSchema';
import { isNewUser } from '../profileParser';
import { isAppUser } from '../appLinks';
import { createPaymentSubmit } from './newPaymentSubmit';

import { store } from '@/store/new-order';
import { showErrorNotification } from '@/store/new-order/notificationsSlice';
import { startSubmitting, stopSubmitting } from '@/store/new-order/submitSlice';
import {
  switchToSuccessStep,
  switchToSuccessStepWithDownload,
  switchToSuccessStepForAppUser,
} from '@/store/new-order/stepsSlice';

const data = {
  getSelectedPlan: () => store.getState().plans.selectedPlan,
  getUserProfile: () => store.getState().user.profile,
  getCouponCode: () => store.getState().coupon.code,
};

const actions = {
  onStartSubmit: () => store.dispatch(startSubmitting()),
  onStopSubmit: () => store.dispatch(stopSubmitting()),
  onSuccess: (profile: UserProfile) => {
    if (isAppUser()) {
      store.dispatch(switchToSuccessStepForAppUser());
    } else if (isNewUser(profile)) {
      store.dispatch(switchToSuccessStepWithDownload());
    } else {
      store.dispatch(switchToSuccessStep());
    }
  },
  showError: (text: string) => store.dispatch(showErrorNotification(text)),
};

const paymentSubmit = createPaymentSubmit(data, actions);

export const { stripePromise, onPaymentRequestSubmit, onCardFormSubmit, onExpressCheckoutConfirm } = paymentSubmit;
